import initialLayerState from "../layer.initialState";
import { reduxActions as LAYER} from "_constants/layer.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const all = {
  [LAYER.ALL_STARTED]: (state) => ({
    ...state,
    all: {
      ...state.all,
      status: LOADING
    }
  }),
  
  [LAYER.ALL_SUCCESS]: (state, { payload }) => ({
    ...state,
    all: {
      ...state.all,
      data: payload?.data ?? null,
      error: null,
      status: SUCCESS
    }
  }),
  
  [LAYER.ALL_FAIL]: (state, { payload }) => ({
    ...state,
    all: {
      ...state.all,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [LAYER.ALL_RESET]: (state) => ({
    ...state,
    all: initialLayerState.all
  })
};

export default all;
